import React from 'react'
import { Select, SelectProps } from 'antd'
import { DefaultOptionType } from 'antd/es/select'
import { Company } from '../../../types/company/Company'
import { useCompanyFormulas } from '../queries/useCompanyFormulas'
import { Formula } from '../types/Formula'

interface FormulaInputProps extends SelectProps {
  companyId?: Company['id']
  optionSelector?: (data: Formula[]) => DefaultOptionType[]
}

const FormulaSelect: React.FC<FormulaInputProps> = ({ companyId, ...selectProps }) => {
  const { data: formulas = [] } = useCompanyFormulas(companyId)

  return (
    <Select
      filterOption={(input, option) => (option?.name?.toString() ?? '').toLowerCase().includes(input.toLowerCase())}
      fieldNames={{
        label: 'name',
        value: 'id'
      }}
      options={formulas}
      allowClear
      showSearch
      maxTagCount="responsive"
      {...selectProps}
    />
  )
}

export default FormulaSelect
